module.exports = __webpack_public_path__ + "static/media/rupee-sign.a149f4fa.svg";